import { gql } from '@apollo/client';
import { queryAllData, queryStationsAndLivingAreas } from './query/houseDivision';

export const GET_HOUSE_DIVISIONS = gql`
  query getHouseDivisions {
    houseDivisions {
      ${queryAllData}
    }
  }
`;

export const GET_HOUSE_DIVISIONS_BY_TYPE = gql`
  query getHouseDivisionsByType($type: HouseDivisionType!) {
    houseDivisions(type: $type) {
      name
      id
    }
  }
`;

export const GET_HOUSE_DIVISION_TREE_BY_RESIDENT = gql`
  query getHouseDivisionTreeByResident($residentId: String!) {
    findHouseDivisionTreeByResident(residentId: $residentId) {
      name
    }
  }
`;

export const CREATE_HOUSE_DIVISION = gql`
mutation createHouseDivision($data: CreateHouseDivisionInput!) {
  createHouseDivision(houseDivision: $data) {
    ${queryAllData}
  }
}
`;

export const UPDATE_HOUSE_DIVISION = gql`
mutation updateHouseDivision($data: UpdateHouseDivisionInput!) {
  updateHouseDivision(houseDivision: $data) {
    ${queryAllData}
  }
}
`;

export const DELETE_HOUSE_DIVISION = gql`
  mutation deleteHouseDivision($data: String!) {
    deleteHouseDivision(id: $data) {
      id
    }
  }
`;

export const REMOVE_RESIDENT_FROM_BED = gql`
  mutation removeResidentFromBed($residentId: String!) {
    removeResidentFromBed(residentId: $residentId)
  }
`;

export const GET_ALL_STATIONS_AND_LIVING_AREAS = gql`
  query getAllStationsAndLivingAreas {
    getAllStationsAndLivingAreas {
      ${queryStationsAndLivingAreas}
    }
  }
`;

export const GET_BED_BY_PREVIOUS_OWNER = gql`
  query findBedByPreviousResident($residentId: String!) {
    findBedByPreviousResident(residentId: $residentId) {
      id
      name
      label
    }
  }
`;
